import { breakpoint, colors, fontSize, fontWeight, mediaQueryHelper, spacing } from '@offerzen/pinata'
import { css } from '@emotion/css'

const styles = {
  standardNavigation: css({
    position: 'fixed',
    backgroundColor: '#131F4A',
    height: '62px',
    width: '100%',
    top: 0,
    zIndex: 600, // z-index has been set this high to avoid conflict with pinata components
    borderBottom: '1px solid rgba(41, 139, 242, 0.2)',
    transform: 'translateZ(1px)',
    padding: 0,

    'a:link': {
      textDecoration: 'none',
    },
  }),

  offerzenLogoImage: css({
    height: 30,
  }),

  navigationBarItems: css({
    display: 'flex',
    flexDirection: 'row',
    maxWidth: '1200px',
    margin: 'auto',
    justifyContent: 'flex-start',
    flexWrap: 'nowrap',
    alignItems: 'center',
    minHeight: '100%',
    padding: `0 10px 0 ${spacing.large}px`,

    [mediaQueryHelper(breakpoint.phone)]: {
      padding: `0 ${spacing.large}px`,
    },
  }),

  navigationLinksContainer: css({
    display: 'none',
    marginLeft: 'auto',

    [mediaQueryHelper(breakpoint.phone)]: {
      display: 'flex',
    },
  }),

  loginButton: css({
    display: 'inline-block',
    fontSize: fontSize.default,
    lineHeight: '20px',
    justifyContent: 'center',
    color: colors.geyser,
    textAlign: 'center',
    alignSelf: 'stretch',
    fontWeight: fontWeight.regular,
    whiteSpace: 'nowrap',
    transition: 'border-color 0.2s cubic-bezier(0.55, 0.085, 0.68, 0.53), background-color 0.4s ease-out',
    width: 'calc(100% - 48px)',
    margin: '10px 24px 0',
    padding: '15px 0',
    flexShrink: 0,
    borderBottom: '1px solid transparent',

    '&:hover': {
      color: colors.white,
      backgroundImage: 'linear-gradient(270deg,rgba(66,156,245,0),rgba(41,139,242,.3))',

      img: {
        transform: 'translate3d(2px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)',
        transformStyle: 'preserve-3d',
      },
    },

    [mediaQueryHelper(breakpoint.phone)]: {
      fontSize: fontSize.small,
      width: 'auto',
      padding: '21px 15px 20px 15px',
      margin: 'auto',

      '&:hover': {
        borderBottom: `1px solid ${colors.cornflowerBlue}`,
        backgroundImage: 'linear-gradient(180deg, rgba(66,156,245,0),rgba(41,139,242,.3))',
      },
    },
  }),

  arrowImage: css({
    height: '8px',
    paddingLeft: spacing.small,
    transition: 'transform .4s ease-out',
    transform: 'translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)',
    transformStyle: 'preserve-3d',
  }),

  mobileNav: css({
    display: 'flex',
    marginLeft: 'auto',
    [mediaQueryHelper(breakpoint.phone)]: {
      display: 'none',
    },
  }),

  filledNavButton: css({
    display: 'flex',
    fontSize: fontSize.default,
    fontWeight: fontWeight.semiBold,
    width: 'calc(100% - 48px)',
    borderWidth: 2,
    borderColor: '#429cf5 #2471c7 #2471c7 #429cf5',
    borderStyle: 'solid',
    backgroundColor: '#2f96f4',
    borderRadius: 4,
    color: colors.white,
    margin: '40px 24px 10px',
    padding: `10px 15px`,
    alignSelf: 'center',
    whiteSpace: 'nowrap',
    transition: 'border-color .3s ease-out,background-color .3s ease-out',
    flexShrink: 0,
    textAlign: 'center',
    alignItems: 'center',
    boxSizing: 'border-box',
    height: 45,

    '&:hover': {
      backgroundColor: colors.mariner,
    },

    [mediaQueryHelper(breakpoint.phone)]: {
      fontSize: fontSize.small,
      padding: `7px 15px`,
      width: 'auto',
      margin: '0 15px',
      height: 35,
    },
  }),

  mobileNavigationMenuItems: css({
    transform: 'translate3d(0,-100%,1px)',
    position: 'fixed',
    top: 62,
    display: 'flex',
    width: '100%',
    backgroundColor: '#131F4A',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    flexWrap: 'nowrap',
    zIndex: 550,
    alignItems: 'center',
    transition: 'transform ease-in .3s',
    height: 'calc(100% - 62px)',
    pointerEvents: 'none',
    paddingBottom: 0,
    overflowY: 'auto',
    flex: '0 auto',
    boxSizing: 'border-box',

    a: {
      textDecoration: 'none',
    },

    [mediaQueryHelper(breakpoint.phone)]: {
      display: 'none',
    },
  }),

  openMobileNavMenuItems: css({
    pointerEvents: 'all',
    transform: 'translate3d(0,0,1px)',
  }),

  mobileMenuLink: css({
    padding: 15,
  }),

  mobileMenuICon: css({
    width: 22,
  }),

  closeMenuContainer: css({
    display: 'flex',
    alignItems: 'flex-end',
    width: '100%',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    flex: '1 0 auto',
    boxSizing: 'border-box',
    pointer: 'cursor',
  }),

  closeMenuNavButton: css({
    padding: '24px 0',
    backgroundColor: 'rgba(47,150,244,.1)',
    color: '#dae0e4',
    boxSizing: 'border-box',
    width: '100%',
    textAlign: 'center',
  }),

  noScroll: css({
    overflow: 'hidden',

    [mediaQueryHelper(breakpoint.phone)]: {
      overflow: 'auto',
    },
  }),
}

export default styles
